import {Component, Input} from '@angular/core';
import {TileType31} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-fuel-supply',
    templateUrl: './tile-fuel-supply.component.html',
    styleUrls: ['./tile-fuel-supply.component.scss']
})
export class TileFuelSupplyComponent {
    @Input() tile: TileType31;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
